import React, { useState } from 'react';
import { BorderGradient, SmallLoader } from 'processhub-components-lib';
import { FiTrash2, FiEdit, FiPlus } from 'react-icons/fi';
import Modal from 'components/Modal/ConfirmationModal';
import DiscountFormModal from './DiscountFormModal';

export interface DiscountCode {
    id: string;
    code: string;
    description: string;
    type: '%' | '$';
    value: string;
    maxRedemptions: number;
    used: number;
}

const Discount = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [isAddModalOpen, setIsAddModalOpen] = useState(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [selectedDiscountId, setSelectedDiscountId] = useState<string | null>(null);
    const [currentPage, setCurrentPage] = useState(1); // starts from 1
    const itemsPerPage = 2; // you can change this number
    const [editedDiscountId, setEditedDiscountId] = useState<string | null>(null);
    const [mode, setMode] = useState("add");
    // Mock data - would be replaced with API calls in production
    const [discountCodes, setDiscountCodes] = useState<DiscountCode[]>([
        {
            id: '1',
            code: 'Spring2024',
            description: 'Spring sale',
            type: '%',
            value: '20%',
            maxRedemptions: 100,
            used: 50
        },
        {
            id: '2',
            code: 'SUMMER2024',
            description: 'Summer sale',
            type: '$',
            value: '$15',
            maxRedemptions: 200,
            used: 80
        },
        {
            id: '3',
            code: 'Cringels',
            description: 'Spring sale',
            type: '%',
            value: '20%',
            maxRedemptions: 100,
            used: 50
        },
        {
            id: '2',
            code: 'Winter2025',
            description: 'Summer sale',
            type: '$',
            value: '$15',
            maxRedemptions: 200,
            used: 80
        },
    ]);

    // Pagination logic
    const totalPages = Math.ceil(discountCodes.length / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const currentDiscountCodes = discountCodes.slice(startIndex, endIndex);
    const pages = Array.from({ length: totalPages }, (_, i) => i + 1);


    const handleAddDiscount = () => {
        setIsAddModalOpen(true);
        setMode("add");
    };

    const handleEditDiscount = (id: string) => {
        // Implement edit functionality
        console.log('Edit discount with ID:', id);
        setMode("edit");
        setEditedDiscountId(id);
        setIsAddModalOpen(true);

    };

    const openDeleteModal = (id: string) => {
        setSelectedDiscountId(id);
        setIsDeleteModalOpen(true);
    };

    const handleDeleteDiscount = () => {
        if (selectedDiscountId) {
            setDiscountCodes(discountCodes.filter(code => code.id !== selectedDiscountId));
            setIsDeleteModalOpen(false);
            setSelectedDiscountId(null);
        }
    };

    return (
        <div className="w-full mt-10">
            <div className="flex justify-between items-center mb-5">
                <h1 className="text-lg font-semibold text-white">Discount code list</h1>
                <button
                    onClick={handleAddDiscount}
                     className="flex items-center gap-2 px-4 py-2 bg-[#2A2A2A] text-white rounded-lg hover:bg-[#3a3a3a33] transition-colors"
                >
                    <FiPlus size={16} />
                    Add discount
                </button>
            </div>

            <div className="bg-[#2A2A2A] rounded-lg overflow-hidden">
                <div className="w-full overflow-x-auto">
                    <table className="min-w-full divide-y divide-white/[0.08]">
                        <thead >
                        <tr className="bg-[#1A1A1A] text-gray-400 text-sm">
                                <th className="text-left p-4 font-medium">
                                    Discount code
                                </th>
                                <th className="text-left p-4 font-medium">
                                    Description
                                </th>
                                <th className="text-left p-4 font-medium">
                                    Type
                                </th>
                                <th className="text-left p-4 font-medium">
                                    Value
                                </th>
                                <th className="text-left p-4 font-medium">
                                    Max redemptions
                                </th>
                                <th className="text-left p-4 font-medium">
                                    Used
                                </th>
                                <th className="text-right p-4 font-medium">
                                    Actions
                                </th>
                            </tr>
                        </thead>
                        <tbody className="">
                            {isLoading ? (
                                <tr>
                                    <td colSpan={7} className="px-6 py-4 text-center">
                                        <div className="flex justify-center">
                                            <SmallLoader />
                                        </div>
                                    </td>
                                </tr>
                            ) : discountCodes.length === 0 ? (
                                <tr>
                                    <td colSpan={7} className="px-6 py-4 text-center text-gray-400">
                                        No discount codes found
                                    </td>
                                </tr>
                            ) : (
                                currentDiscountCodes.map((code) => (
                                    <tr key={code.id} className="border-b border-white/[0.08] hover:bg-[#3a3a3a33]">
                                        <td className="p-4 text-gray-300">
                                            {code.code}
                                        </td>
                                        <td className="p-4 text-gray-300">
                                            {code.description}
                                        </td>
                                        <td className="p-4 text-gray-300">
                                            {code.type}
                                        </td>
                                        <td className="p-4 text-gray-300">
                                            {code.value}
                                        </td>
                                        <td className="p-4 text-gray-300">
                                            {code.maxRedemptions}
                                        </td>
                                        <td className="p-4 text-gray-300">
                                            {code.used}
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                                            <div className="flex justify-end gap-3">
                                                <button
                                                    onClick={() => handleEditDiscount(code.id)}
                                                    className="text-blue-500 hover:text-blue-400"
                                                >
                                                    <FiEdit size={18} />
                                                </button>
                                                {/* <button
                                                    onClick={() => openDeleteModal(code.id)}
                                                    className="text-red-500 hover:text-red-400"
                                                >
                                                    <FiTrash2 size={18} />
                                                </button> */}
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
                {/* Pagination */}
               



            </div>
            <div className="flex items-center justify-between mt-4 text-sm text-gray-400">
                    <div>
                        Showing {startIndex + 1}-{Math.min(endIndex, discountCodes.length)} from {discountCodes.length}
                    </div>
                    <div className="flex items-center gap-2">
                        <button
                            onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                            disabled={currentPage === 1}
                            className="p-2 hover:text-white disabled:opacity-50"
                        >
                            ←
                        </button>
                        {pages.map(page => (
                            <button
                                key={page}
                                onClick={() => setCurrentPage(page)}
                                className={`w-8 h-8 rounded flex items-center justify-center ${currentPage === page
                                    ? 'bg-[#3A3A3A] text-white'
                                    : 'hover:text-white'
                                    }`}
                            >
                                {page}
                            </button>
                        ))}
                        <button
                            onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                            disabled={currentPage === totalPages}
                            className="p-2 hover:text-white disabled:opacity-50"
                        >
                            →
                        </button>
                    </div>
                </div>

            {/* Confirmation Modal for Delete */}
            <Modal
                isOpen={isDeleteModalOpen}
                message="Are you sure you want to delete this discount code?"
                onConfirm={handleDeleteDiscount}
                onCancel={() => setIsDeleteModalOpen(false)}
            />

            {isAddModalOpen && <DiscountFormModal
                mode={mode}
                discountCodes={discountCodes}
                editedDiscountId={editedDiscountId}
                setMode={setMode}
                isOpen={isAddModalOpen}
                onClose={() => setIsAddModalOpen(false)} setDiscountCodes={setDiscountCodes} />}
        </div>
    );
};

export default Discount;